export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["LOAD_FLAGS"] = "[WebAngularSharedDataAccessFeatureFlagApi] LOAD FLAGS";
    ActionTypes["LOAD_FLAGS_FROM_CONFIG"] = "[WebAngularSharedDataAccessFeatureFlagApi] LOAD FLAGS FROM CONFIG";
    ActionTypes["SET_FLAGS"] = "[WebAngularSharedDataAccessFeatureFlagApi] SET FLAGS";
    ActionTypes["UPDATE_FLAGS"] = "[WebAngularSharedDataAccessFeatureFlagApi] UPDATE FLAGS";
    ActionTypes["INITIALIZATION_COMPLETE"] = "[WebAngularSharedDataAccessFeatureFlagApi] INITIALIZATION_COMPLETE";
})(ActionTypes || (ActionTypes = {}));
export class LoadFlags {
    constructor() {
        this.type = ActionTypes.LOAD_FLAGS;
    }
}
export class LoadFlagsFromConfig {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.LOAD_FLAGS_FROM_CONFIG;
    }
}
export class SetFlags {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.SET_FLAGS;
    }
}
export class UpdateFlags {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.UPDATE_FLAGS;
    }
}
export class InitalizationCompleteAction {
    constructor(payload) {
        this.payload = payload;
        this.type = ActionTypes.INITIALIZATION_COMPLETE;
    }
}
//# sourceMappingURL=feature-flag.actions.js.map